import { createContext, useContext } from 'react';

// containerHistory is injected by the qiankun parent app as a history-like object.
// When running standalone it may be undefined — fall back to window.location.
const fallbackHistory = {
  push: (to: string | { pathname?: string; search?: string }) => {
    if (typeof to === 'string') {
      window.location.href = to;
    } else {
      window.location.href = (to.pathname ?? '') + (to.search ?? '');
    }
  },
};

export const ContainerHistory = createContext<any>(fallbackHistory);

export const useContainerHistory = (): typeof fallbackHistory => {
  const history = useContext(ContainerHistory);
  // history may be passed as a bare function (legacy pattern) — normalise to { push }
  if (typeof history === 'function') {
    return { push: history };
  }
  return history ?? fallbackHistory;
};
